import { inject, Injectable } from '@angular/core';
import { AuthConfig } from '../../environments/environment';
import { UserStateService } from './user-state.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly accessTokenKey = 'access_token';
  private readonly userStateService = inject(UserStateService);

  setAccessToken(token: string) {
    localStorage.setItem(this.accessTokenKey, token);
  }

  getAccessToken(): string | null {
    return localStorage.getItem(this.accessTokenKey);
  }

  isAuthenticated(): boolean {
    const hasToken = !!this.getAccessToken();
    return window.location.hostname === 'localhost' || hasToken;
  }

  logout() {
    localStorage.removeItem(this.accessTokenKey);
    this.userStateService.clearUserIdentity();
    // Remove legacy identity keys from previous implementation.
    localStorage.removeItem('userId');
    localStorage.removeItem('name');
    localStorage.removeItem('surname');
    localStorage.removeItem('email');
    localStorage.removeItem('employeeName');
    localStorage.removeItem('department');
  }

  getAuthUrl(): string {
    return `${AuthConfig.AMBaseURL}/oauth2/${AuthConfig.realmPath}/authorize?client_id=${AuthConfig.clientId}&state=${AuthConfig.state}&scope=${AuthConfig.scopes}&redirect_uri=${AuthConfig.redirectUri}&response_type=token%20id_token&nonce=${AuthConfig.nonce}`;
  }

  handleRedirect() {
    const hash = window.location.hash;
    if (hash) {
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get('access_token');
      if (accessToken) {
        this.setAccessToken(accessToken);
        // Remove the hash from the URL before reload
        history.replaceState(
          null,
          '',
          window.location.pathname + window.location.search,
        );
        window.location.reload();
        return;
      }
    }
    window.location.href = this.getAuthUrl();
  }

  handleRefreshRedirect() {
    window.location.href = this.getAuthUrl();
  }
}
